import React from "react";
import { Button } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 } from "../../../../services/apis";
import { ButtonsWrapper, Wraper } from "./styles";

export const RelatoriosEmpresas = () => {
  const fetchRelatorio = async (name) => {
    try {
      const response = await producaov2.post(`/admin/reports/${name}`);
      window.open(response.data);
    } catch (error) {
      console.error("Error fetching or opening report:", error);
    }
  };

  return (
    <div style={{width:"100%", paddingLeft:"250px"}}>
      <AdminMenu />
      <Wraper>
        <ButtonsWrapper>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-new-general");
            }}
          >
            Gerar relatórios Geral inCompany novo
          </Button>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-new-times");
            }}
          >
            Gerar relatórios de Times inCompany novo
          </Button>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-new-trilhas");
            }}
          >
            Gerar relatórios de Trilhas inCompany novo
          </Button>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-new-colaboradores");
            }}
          >
            Gerar relatórios de Colaboradores inCompany novo
          </Button>
        </ButtonsWrapper>

        <ButtonsWrapper>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-old-general");
            }}
          >
            Gerar relatórios Geral inCompany antigo
          </Button>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-old-planos");
            }}
          >
            Gerar relatórios de Planos inCompany antigo
          </Button>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-old-trilhas");
            }}
          >
            Gerar relatórios de Trilhas inCompany antigo
          </Button>
          <Button
            onClick={() => {
              fetchRelatorio("incompany-old-colaboradores");
            }}
          >
            Gerar relatórios de Colaboradores inCompany antigo
          </Button>
        </ButtonsWrapper>
      </Wraper>
    </div>
  );
};
